import Vue from 'vue'
import Vuex from 'vuex'

import api from '@/api'

// Modules
import cart from './modules/cart'
import deliveryAddress from './modules/deliveryAddress'
import formOptions from './modules/formOptions'
import invoiceAddress from './modules/invoiceAddress'
import modal from './modules/modal'
import payment from './modules/payment'
import shipping from './modules/shipping'
import summary from './modules/summary'
import translations from './modules/translations'
import vouchers from './modules/vouchers'
import auth from './modules/auth'
import settings from './modules/settings'

Vuex.Store.prototype.api = api

Vue.use(Vuex)

const state = {}
const actions = {}
const mutations = {}
const getters = {}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    cart,
    deliveryAddress,
    formOptions,
    invoiceAddress,
    modal,
    payment,
    shipping,
    summary,
    translations,
    vouchers,
    auth,
    settings,
  },
  strict: process.env.NODE_ENV !== 'production',
})
